"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sidebarNavStyles = void 0;

var _styledComponents = require("styled-components");

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var sidebarNavStyles = {
  borderLeft: (0, _styledComponents.css)(["1px solid ", ""], (0, _getColor.getColor)('borders', 'light')),
  borderLeftSpacing: (0, _getSpacing.getSpacing)(6),
  item: {
    marginY: (0, _getSpacing.getSpacing)(4),
    focus: {
      outlineColor: (0, _getColor.getColor)('brand', 'lightest'),
      outlineSize: (0, _getSpacing.getSpacing)(2)
    },
    active: {
      backgroundColor: (0, _getColor.getColor)('brand', 'light'),
      outlineSize: (0, _getSpacing.getSpacing)(2)
    },
    selected: {
      backgroundColor: (0, _getColor.getColor)('brand', 'lightest')
    },
    hover: {
      backgroundColor: (0, _getColor.getColor)('brand', 'lightest')
    }
  }
};
exports.sidebarNavStyles = sidebarNavStyles;